import axios from 'axios';
console.log(import.meta.env.VITE_URL_BASE_API);
const api = axios.create({
  baseURL: import.meta.env.VITE_URL_BASE_API || '/api',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

export default api;
